"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Utilities_1 = require("../../../javascript/Utilities");
exports.default = {
    impl(ids, parentId, relId, completedHandler, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const guid = Utilities_1.synUtil.getGUID(true);
                const contentTempDownloadableUrl = Utilities_1.synUtil.getWSUrl("ContentTempDownloadable");
                const contentTempDownloadUrl = Utilities_1.synUtil.getWSUrl("ContentTempDownload");
                Utilities_1.synUtil.beginAjaxProgress();
                try {
                    yield Utilities_1.synUtil.executeMethodAsync({
                        method: "admfunc.16",
                        ids,
                        parentId,
                        relId,
                        additionalData: {
                            tempPathGUID: guid,
                            tempPathTarget: "admfunc.16resultfilepath"
                        }
                    });
                    Utilities_1.synUtil.beginAjaxProgress();
                    try {
                        const data = yield Utilities_1.synUtil.getAJAXDataAsync({ url: contentTempDownloadableUrl + guid });
                        if (data.downloadable)
                            $.fileDownload(contentTempDownloadUrl + guid + "?csrfToken=" + Utilities_1.synUtil.requestVerificationToken + "&forceAttachment=true");
                    }
                    finally {
                        Utilities_1.synUtil.endAjaxProgress();
                    }
                }
                finally {
                    Utilities_1.synUtil.endAjaxProgress();
                }
            }
            catch (err) {
                // synUtil.Notifications.error(err, { autoHideAfter: 12000 });
            }
        });
    }
};
